module.exports = __webpack_public_path__ + "static/media/msPowerPlatform.92576b02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/msPowerPlatform.jpg
// module id = 795
// module chunks = 5